var render = function render(){var _vm=this,_c=_vm._self._c;return _c('figure',{staticClass:"kim",style:(`
    background-image: url(${require('@/assets/kim/kim-'+ _vm.mood + '.svg')});
    background-color: ${_vm.color};
    background-position: ${_vm.returnPosition}`)})
}
var staticRenderFns = []

export { render, staticRenderFns }